/*
 * @name: 新闻信息
 * @
 * @Author: 黄晓玲
 * @Date: 2022-12-02 09:59:28
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2023-02-10 16:03:13
 * @Description: 描述
 */

<template>
  <div class="">
    <el-row
      :type="+type === 3 ? '' : 'flex'"
      :justify="+type === 3 ? 'start' : 'center'"
    >
      <el-col
        :xs="+type === 3 ? 24 : 22"
        :sm="+type === 3 ? 24 : 22"
        :md="+type === 3 ? 24 : 18"
      >
        <div v-if="[1, 3].includes(+type)" class="companyListBox">
          <el-row :gutter="companyGutter" :type="+type === 3 ? '' : 'flex'">
            <el-col
              :xs="24"
              :sm="24"
              :md="8"
              v-for="(item, index) in newsDynamicData"
              :key="index"
            >
              <div class="companyList">
                <div class="companyListImgBox">
                  <el-image class="companyImg" :src="item.pic"> </el-image>
                </div>
                <div class="companyContentBox">
                  <div class="companyListDate">
                    <div class="dateDay">{{ item.create_time_mouth }}</div>
                    <div class="dateYear">{{ item.create_time_year }}</div>
                  </div>
                  <div class="companyListTitle">{{ item.title }}</div>
                  <div class="companyListContent" v-html="xss(item.remark)"></div>
                  <div class="butt" @click="goDetailPage(item.id)">
                    <span>{{$t('productCenter.viewNow')}}</span>
                    <i class="el-icon-arrow-right direacion"></i>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-if="[2, 4, 5].includes(+type)" class="newsListBox">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24">
              <div class="newsList_Left">
                <div
                  class="newsList"
                  v-for="(item, index) in newsDynamicData"
                  :key="index"
                  @click="goDetailPage(item.id)"
                >
                  <el-col :xs="7" :sm="3" :md="3" :lg="3" :xl="3">
                    <div class="newsDate">{{ item.publish_time }}</div>
                  </el-col>
                  <el-col :xs="16" :sm="21" :md="21" :lg="21" :xl="21">
                    <div class="newsTitle">{{ item.title }}</div>
                  </el-col>
                </div>

                <!-- 暂无数据 -->
                <div v-if="newsDynamicData.length === 0" class="noData">
                  暂无数据
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { localStorage } from "@/utils/storage.js";
import { formatTimeNum, parseTime, routeName } from "@/utils";
import * as acticleApi from "@/api/acticle/acticle";
const typeData = {
  1: { tyep: 3000, name: "首页-新闻信息" },
  2: { tyep: 3001, name: "新闻-行业动态-查看所有动态" },
  3: { tyep: 3001, name: "新闻-行业动态" },
  4: { tyep: 3000, name: "新闻-新闻信息-查看所有动态" },
  5: { tyep: 3014, name: "新闻-行业动态-查看所有动态" },
};

export default {
  name: "industryTrends",
  props: {
    type: {
      type: [Number, String],
      default: 1,
    },
    search: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 3,
        };
      },
    },
  },
  data() {
    return {
      // 公司简介新闻数据
      newsDynamicData: [],
      companyGutter: 25,
      typeData,
    };
  },
  mounted() {
    // 监听屏幕变化
    window.onresize = () => {
      //屏幕尺寸变化就重新赋值
      return (() => {
        if (document.body.clientWidth < 768) {
          this.companyGutter = 0;
        } else {
          this.companyGutter = 25;
        }
      })();
    };
    this.getDynamicData(); //获取公司简介
  },
  methods: {
    // 获取公司简介数据
    getDynamicData() {
      const lang = localStorage.get("language") || "zh";
      this.search.id = typeData[this.type].tyep;
      acticleApi
        .getIndex(this.search)
        .then((res) => {
          // home.readNews(this.search).then((res) => {
          let data = res.data.data;
          for (let item of data) {
            item.create_time_year = formatTimeNum(item.create_time, "Y");
            item.create_time_mouth = formatTimeNum(
              item.create_time,
              lang == "en" ? "M-D" : "M月D日"
            );
            item.publish_time = parseTime(item.publish_time, "{y}-{m}-{d}");
          }
          this.newsDynamicData = data;
          this.$emit("change", res.data);
        })
        .catch((res) => {});
    },
    // 公司简介详情
    goDetailPage(id) {
      this.$router.push({ path: "/newsDetail", query: { id: id } });
    },
  },
};
</script>

<style scoped>
.noData {
  opacity: 0.5;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  line-height: 3;
}
.companyBox {
  padding: 20px;
}
/* 公司概况 */
.newsListBox,
.companyListBox {
  width: 100%;
}
.companyList {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  margin: 20px 0;
  box-shadow: 0 0 10px #dcdfe6;
  transition: all 0.3s;
  position: relative;
}
.companyList:hover {
  margin-top: 10px;
}
.companyListImgBox {
  width: 100%;
  /* height: 200px; */
  height: 15vmax;
}
.companyImg {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
}
.companyContentBox {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 15px;
}
.companyListDate {
  width: 100%;
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}
.dateDay {
  font-size: 20px;
  color: #787b8a;
  margin-right: 10px;
}
.dateYear {
  font-size: 16px;
  color: #787b8a;
}
.companyListTitle {
  width: 100%;
  margin: 0 0 20px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  line-height: 1.6;
  display: -webkit-box;
  overflow: hidden;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.companyListContent {
  width: 100%;
  font-size: 14px;
  color: #333333;
  line-height: 2.2;
  display: -webkit-box;
  overflow: hidden;
  /*! autoprefixer: off; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  min-height: 154px;
  margin-bottom: 50px;
}
.butt {
  font-size: 13px;
  width: 110px;
  padding: 5px;
  border: 1px solid #9d9ea7;
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  color: #9d9ea7;
}
.direacion {
  padding: 1px;
  margin-left: 20px;
  border: 1px solid #9d9ea7;
  border-radius: 50%;
  font-size: 12px;
}

.newsList {
  width: 100%;
  display: flex;
  margin-bottom: 25px;
  cursor: pointer;
}
.newsDate {
  color: #787b8a;
  font-size: 14px;
}
.newsTitle {
  color: #333333;
  font-size: 16px;
}
/* 响应式样式 */

@media only screen and (max-width: 992px) {
  .companyList {
    margin: 14px 0;
  }
  .companyListImgBox {
    height: 40vw;
  }
  .el-row--flex {
    flex-direction: column;
    align-items: center;
  }
  .companyListContent {
    line-height: 1.7;
    min-height: 80px;
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 768px) {
}
@media screen and (min-width: 992px) {
}

@media screen and (min-width: 1200px) {
}

@media screen and (min-width: 1400px) {
}

@media screen and (min-width: 1920px) {
}
</style>
